import { Breadcrumbs } from "../_components/Breadcrums";

const breadcrumbList = [
  { 
    title: "Dashboard",
    href: "/admin/dashboard" 
  },

];

export default function AdminDashboard() {
  return (
    <div>
      <Breadcrumbs list={breadcrumbList}/>
      <div>
    
      </div>
    </div>
  )
}
